/**
 * Serialize an object of key/value pairs to URL query parameters
 *
 * @param {Object} paramsObj Object containing params to be serialized
 * @return string
 */
export default function serializeUrlParams(paramsObj) {
  return Object.entries(paramsObj)
    .map(([key, val]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
    })
    .join('&')
}
